import { adminSchema } from '@/lib/supabase/client'

export interface SystemSetting {
  key: string
  value: unknown
  description: string | null
  updated_by: string | null
  updated_at: string
}

export async function fetchSettings(): Promise<SystemSetting[]> {
  const { data, error } = await adminSchema()
    .from('system_settings')
    .select('*')
    .order('key')
  if (error) throw error
  return data as SystemSetting[]
}
